import { defineMessages } from 'react-intl';

// English strings are placeholders pending design copy.
//
// One trio per distinct Work-timeline tool label: `…Active` while the call
// (or same-name group) runs, `…Past` once it succeeds, `…PastPartial` when a
// grouped run ends with only some calls finished. `count` is the number of
// grouped calls (1 for a single row); `done` is how many finished.
export const toolLabelMessages = defineMessages({
  readClinicianNoteActive: {
    defaultMessage:
      '{count, plural, one {Reading clinician note} other {Reading # clinician notes}}',
    id: 'EoIjnEbyox',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  readClinicianNotePast: {
    defaultMessage:
      '{count, plural, one {Read clinician note} other {Read # clinician notes}}',
    id: 'MjVNVnqSri',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  readClinicianNotePastPartial: {
    defaultMessage: 'Read {done} of {count} clinician notes',
    id: '1kv00aeMoY',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  updatedClinicianNoteActive: {
    defaultMessage:
      '{count, plural, one {Updating clinician note} other {Updating # clinician notes}}',
    id: '2bhmnkArYd',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  updatedClinicianNotePast: {
    defaultMessage:
      '{count, plural, one {Updated clinician note} other {Updated # clinician notes}}',
    id: '2Or6R715St',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  updatedClinicianNotePastPartial: {
    defaultMessage: 'Updated {done} of {count} clinician notes',
    id: 'frM4VdzHei',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdPatientActive: {
    defaultMessage: '{count, plural, one {Creating patient} other {Creating # patients}}',
    id: 'b4VcOOdi/I',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdPatientPast: {
    defaultMessage: '{count, plural, one {Created patient} other {Created # patients}}',
    id: 'PWF4BOVqmL',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdPatientPastPartial: {
    defaultMessage: 'Created {done} of {count} patients',
    id: 'DDx0Yg+JGJ',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  updatedPatientActive: {
    defaultMessage: '{count, plural, one {Updating patient} other {Updating # patients}}',
    id: 'c6vHp0rwAZ',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  updatedPatientPast: {
    defaultMessage: '{count, plural, one {Updated patient} other {Updated # patients}}',
    id: 'lV94CTp0RM',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  updatedPatientPastPartial: {
    defaultMessage: 'Updated {done} of {count} patients',
    id: 'odTBqMfZ1y',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  mergedPatientProfilesActive: {
    defaultMessage:
      '{count, plural, one {Merging patient profiles} other {Merging # patient profiles}}',
    id: 'Tq8EhThhms',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  mergedPatientProfilesPast: {
    defaultMessage:
      '{count, plural, one {Merged patient profiles} other {Merged # patient profiles}}',
    id: 'WbzPPJC7TE',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  mergedPatientProfilesPastPartial: {
    defaultMessage: 'Merged {done} of {count} patient profiles',
    id: '89RQVgIOdc',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  uploadedPatientDocumentActive: {
    defaultMessage:
      '{count, plural, one {Uploading patient document} other {Uploading # patient documents}}',
    id: 'ZFBwOpsYOS',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  uploadedPatientDocumentPast: {
    defaultMessage:
      '{count, plural, one {Uploaded patient document} other {Uploaded # patient documents}}',
    id: 'HXDvwo4kEb',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  uploadedPatientDocumentPastPartial: {
    defaultMessage: 'Uploaded {done} of {count} patient documents',
    id: 'NlMCjyMyt3',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedPatientDocumentsActive: {
    defaultMessage:
      '{count, plural, one {Listing patient documents} other {Listing # patient documents}}',
    id: '8W2FR3sbol',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedPatientDocumentsPast: {
    defaultMessage:
      '{count, plural, one {Listed patient documents} other {Listed # patient documents}}',
    id: 'EqmC1ywFCb',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedPatientDocumentsPastPartial: {
    defaultMessage: 'Listed {done} of {count} patient documents',
    id: 'Lo/dDvkI5Q',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  readPatientDocumentActive: {
    defaultMessage:
      '{count, plural, one {Reading patient document} other {Reading # patient documents}}',
    id: 'AL8uUi8pwb',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  readPatientDocumentPast: {
    defaultMessage:
      '{count, plural, one {Read patient document} other {Read # patient documents}}',
    id: '6c5ucvmGFf',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  readPatientDocumentPastPartial: {
    defaultMessage: 'Read {done} of {count} patient documents',
    id: 'SgSlH3TCgn',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdSessionActive: {
    defaultMessage: '{count, plural, one {Creating session} other {Creating # sessions}}',
    id: 'tWOXMwidGU',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdSessionPast: {
    defaultMessage: '{count, plural, one {Created session} other {Created # sessions}}',
    id: '7zj7XoGND+',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdSessionPastPartial: {
    defaultMessage: 'Created {done} of {count} sessions',
    id: 'sBMYmY0TeP',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdTeammateSessionActive: {
    defaultMessage:
      '{count, plural, one {Creating teammate session} other {Creating # teammate sessions}}',
    id: 'YSZ1i+nfPR',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdTeammateSessionPast: {
    defaultMessage:
      '{count, plural, one {Created teammate session} other {Created # teammate sessions}}',
    id: 'qaV6ygdr8U',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdTeammateSessionPastPartial: {
    defaultMessage: 'Created {done} of {count} teammate sessions',
    id: 'NKNm93rlxb',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  deletedSessionActive: {
    defaultMessage: '{count, plural, one {Deleting session} other {Deleting # sessions}}',
    id: 'IsLJBrRuVb',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  deletedSessionPast: {
    defaultMessage: '{count, plural, one {Deleted session} other {Deleted # sessions}}',
    id: 'RdEhGcG8RC',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  deletedSessionPastPartial: {
    defaultMessage: 'Deleted {done} of {count} sessions',
    id: 'uB/uCb6Z18',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  emailedSessionEmailActive: {
    defaultMessage:
      '{count, plural, one {Emailing session email} other {Emailing # session emails}}',
    id: 'Hdtit6Njhd',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  emailedSessionEmailPast: {
    defaultMessage:
      '{count, plural, one {Emailed session email} other {Emailed # session emails}}',
    id: 'D8R7ylQ+1X',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  emailedSessionEmailPastPartial: {
    defaultMessage: 'Emailed {done} of {count} session emails',
    id: 'XgGCxxlCW6',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  deletedTemplateActive: {
    defaultMessage:
      '{count, plural, one {Deleting template} other {Deleting # templates}}',
    id: 'BLaxI8E1RN',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  deletedTemplatePast: {
    defaultMessage: '{count, plural, one {Deleted template} other {Deleted # templates}}',
    id: 'dU0KktFe4M',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  deletedTemplatePastPartial: {
    defaultMessage: 'Deleted {done} of {count} templates',
    id: 'hngZv7JIsF',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  openedTemplateEditorActive: {
    defaultMessage:
      '{count, plural, one {Opening template editor} other {Opening # template editors}}',
    id: '18QEtkb9QK',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  openedTemplateEditorPast: {
    defaultMessage:
      '{count, plural, one {Opened template editor} other {Opened # template editors}}',
    id: 'sUIsUVIvGb',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  openedTemplateEditorPastPartial: {
    defaultMessage: 'Opened {done} of {count} template editors',
    id: '49CBhPK4cR',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  pinnedTemplateActive: {
    defaultMessage: '{count, plural, one {Pinning template} other {Pinning # templates}}',
    id: 'VicSNWjjxN',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  pinnedTemplatePast: {
    defaultMessage: '{count, plural, one {Pinned template} other {Pinned # templates}}',
    id: 'rkc2tgVIMH',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  pinnedTemplatePastPartial: {
    defaultMessage: 'Pinned {done} of {count} templates',
    id: '1o6mBNRFRa',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  unpinnedTemplateActive: {
    defaultMessage:
      '{count, plural, one {Unpinning template} other {Unpinning # templates}}',
    id: '+/gjzftLBl',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  unpinnedTemplatePast: {
    defaultMessage:
      '{count, plural, one {Unpinned template} other {Unpinned # templates}}',
    id: 'uF4jgFU6Wb',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  unpinnedTemplatePastPartial: {
    defaultMessage: 'Unpinned {done} of {count} templates',
    id: '/RimlvnTkw',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  generatedPrechartActive: {
    defaultMessage:
      '{count, plural, one {Generating prechart} other {Generating # precharts}}',
    id: 'Y8ZxeBrcgs',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  generatedPrechartPast: {
    defaultMessage:
      '{count, plural, one {Generated prechart} other {Generated # precharts}}',
    id: '87Ke41K3U8',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  generatedPrechartPastPartial: {
    defaultMessage: 'Generated {done} of {count} precharts',
    id: '8KrXdfGzUi',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  checkedTemplateUsageActive: {
    defaultMessage:
      '{count, plural, one {Checking template usage} other {Checking # template usages}}',
    id: '/MELw6rNaC',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  checkedTemplateUsagePast: {
    defaultMessage:
      '{count, plural, one {Checked template usage} other {Checked # template usages}}',
    id: 'sahlmyzRd4',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  checkedTemplateUsagePastPartial: {
    defaultMessage: 'Checked {done} of {count} template usages',
    id: '8bZIgaaIhL',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedTemplateUsageActive: {
    defaultMessage:
      '{count, plural, one {Listing template usage} other {Listing # template usages}}',
    id: 'ni9G6VPRl7',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedTemplateUsagePast: {
    defaultMessage:
      '{count, plural, one {Listed template usage} other {Listed # template usages}}',
    id: 'lO+eWzc+0X',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedTemplateUsagePastPartial: {
    defaultMessage: 'Listed {done} of {count} template usages',
    id: 'IGFyOS0Vuq',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  analysedTemplatePerformanceActive: {
    defaultMessage:
      '{count, plural, one {Analysing template performance} other {Analysing # template performances}}',
    id: 'bSejOEgf6j',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  analysedTemplatePerformancePast: {
    defaultMessage:
      '{count, plural, one {Analysed template performance} other {Analysed # template performances}}',
    id: '3TfCTxAhJ/',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  analysedTemplatePerformancePastPartial: {
    defaultMessage: 'Analysed {done} of {count} template performances',
    id: 'Rwv0DSzDYA',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  summarisedTeamInsightsActive: {
    defaultMessage:
      '{count, plural, one {Summarising team insights} other {Summarising # team insights}}',
    id: '0tDe95A/zM',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  summarisedTeamInsightsPast: {
    defaultMessage:
      '{count, plural, one {Summarised team insights} other {Summarised # team insights}}',
    id: 'r9pIbnJZPC',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  summarisedTeamInsightsPastPartial: {
    defaultMessage: 'Summarised {done} of {count} team insights',
    id: 'DzbTVqgO8X',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  fetchedClinicalCodesActive: {
    defaultMessage:
      '{count, plural, one {Fetching clinical codes} other {Fetching # clinical codes}}',
    id: '5aRtVJHU+a',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  fetchedClinicalCodesPast: {
    defaultMessage:
      '{count, plural, one {Fetched clinical codes} other {Fetched # clinical codes}}',
    id: 'xuQITXOiTo',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  fetchedClinicalCodesPastPartial: {
    defaultMessage: 'Fetched {done} of {count} clinical codes',
    id: 'GvzknOIbV8',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  confirmedClinicalCodesActive: {
    defaultMessage:
      '{count, plural, one {Confirming clinical codes} other {Confirming # clinical codes}}',
    id: '53QOYjk+j4',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  confirmedClinicalCodesPast: {
    defaultMessage:
      '{count, plural, one {Confirmed clinical codes} other {Confirmed # clinical codes}}',
    id: 'a3/7zQ/qji',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  confirmedClinicalCodesPastPartial: {
    defaultMessage: 'Confirmed {done} of {count} clinical codes',
    id: 'ezusqC1YEb',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  rejectedClinicalCodeActive: {
    defaultMessage:
      '{count, plural, one {Rejecting clinical code} other {Rejecting # clinical codes}}',
    id: '6/P2OQO9mm',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  rejectedClinicalCodePast: {
    defaultMessage:
      '{count, plural, one {Rejected clinical code} other {Rejected # clinical codes}}',
    id: 'Ii3jAWrudn',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  rejectedClinicalCodePastPartial: {
    defaultMessage: 'Rejected {done} of {count} clinical codes',
    id: 'jGU30yLZVO',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  addedClinicalCodeActive: {
    defaultMessage:
      '{count, plural, one {Adding clinical code} other {Adding # clinical codes}}',
    id: 'biERZlX48f',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  addedClinicalCodePast: {
    defaultMessage:
      '{count, plural, one {Added clinical code} other {Added # clinical codes}}',
    id: 'bN4iGSmrPy',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  addedClinicalCodePastPartial: {
    defaultMessage: 'Added {done} of {count} clinical codes',
    id: '7JbFji/zkA',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  fetchedTeamSessionSharingActive: {
    defaultMessage:
      '{count, plural, one {Fetching team session sharing} other {Fetching # team session sharings}}',
    id: 'NhU8c6I/Xa',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  fetchedTeamSessionSharingPast: {
    defaultMessage:
      '{count, plural, one {Fetched team session sharing} other {Fetched # team session sharings}}',
    id: 'rgdfJOcGxD',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  fetchedTeamSessionSharingPastPartial: {
    defaultMessage: 'Fetched {done} of {count} team session sharings',
    id: '3UPVRFM+lf',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  updatedTeamSessionSharingActive: {
    defaultMessage:
      '{count, plural, one {Updating team session sharing} other {Updating # team session sharings}}',
    id: 'Y5JLOgvpjD',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  updatedTeamSessionSharingPast: {
    defaultMessage:
      '{count, plural, one {Updated team session sharing} other {Updated # team session sharings}}',
    id: 'UrIbsBXGjl',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  updatedTeamSessionSharingPastPartial: {
    defaultMessage: 'Updated {done} of {count} team session sharings',
    id: 'cW63gHDJHT',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  setSessionTitleActive: {
    defaultMessage:
      '{count, plural, one {Setting session title} other {Setting # session titles}}',
    id: 'nPiquyOCer',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  setSessionTitlePast: {
    defaultMessage:
      '{count, plural, one {Set session title} other {Set # session titles}}',
    id: '7IEYCvRF8J',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  setSessionTitlePastPartial: {
    defaultMessage: 'Set {done} of {count} session titles',
    id: 'W1oOcq0LDP',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  linkedSessionActive: {
    defaultMessage: '{count, plural, one {Linking session} other {Linking # sessions}}',
    id: 'jt0nCZ0npA',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  linkedSessionPast: {
    defaultMessage: '{count, plural, one {Linked session} other {Linked # sessions}}',
    id: 'RNFfnkNNkj',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  linkedSessionPastPartial: {
    defaultMessage: 'Linked {done} of {count} sessions',
    id: 'h8GV6Vk06N',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  addedContextNoteActive: {
    defaultMessage:
      '{count, plural, one {Adding context note} other {Adding # context notes}}',
    id: '9+bH+7Nsnh',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  addedContextNotePast: {
    defaultMessage:
      '{count, plural, one {Added context note} other {Added # context notes}}',
    id: 'LTEKaow6j2',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  addedContextNotePastPartial: {
    defaultMessage: 'Added {done} of {count} context notes',
    id: 'URfvthxICj',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  addedContextDocumentActive: {
    defaultMessage:
      '{count, plural, one {Adding context document} other {Adding # context documents}}',
    id: 'S2UIZ/DSbP',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  addedContextDocumentPast: {
    defaultMessage:
      '{count, plural, one {Added context document} other {Added # context documents}}',
    id: '2Pe9PXhhrg',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  addedContextDocumentPastPartial: {
    defaultMessage: 'Added {done} of {count} context documents',
    id: 'EgXLJwAF+r',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  updatedContextDocumentActive: {
    defaultMessage:
      '{count, plural, one {Updating context document} other {Updating # context documents}}',
    id: '/MI++qkK/8',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  updatedContextDocumentPast: {
    defaultMessage:
      '{count, plural, one {Updated context document} other {Updated # context documents}}',
    id: 'zP7wH9zKpH',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  updatedContextDocumentPastPartial: {
    defaultMessage: 'Updated {done} of {count} context documents',
    id: '5BSywLMJAW',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  deletedContextDocumentActive: {
    defaultMessage:
      '{count, plural, one {Deleting context document} other {Deleting # context documents}}',
    id: '+ZbscKf6p0',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  deletedContextDocumentPast: {
    defaultMessage:
      '{count, plural, one {Deleted context document} other {Deleted # context documents}}',
    id: 'fRtiUwjRGO',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  deletedContextDocumentPastPartial: {
    defaultMessage: 'Deleted {done} of {count} context documents',
    id: 'o4tMKkMYQe',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedContextDocumentActive: {
    defaultMessage:
      '{count, plural, one {Listing context document} other {Listing # context documents}}',
    id: 'R/VlcnJaEz',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedContextDocumentPast: {
    defaultMessage:
      '{count, plural, one {Listed context document} other {Listed # context documents}}',
    id: 'Yqv1aJ0KAz',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedContextDocumentPastPartial: {
    defaultMessage: 'Listed {done} of {count} context documents',
    id: '9D40t+xJXN',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  readContextDocumentActive: {
    defaultMessage:
      '{count, plural, one {Reading context document} other {Reading # context documents}}',
    id: 'k5tzK7P6zB',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  readContextDocumentPast: {
    defaultMessage:
      '{count, plural, one {Read context document} other {Read # context documents}}',
    id: '5ey90tTwuX',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  readContextDocumentPastPartial: {
    defaultMessage: 'Read {done} of {count} context documents',
    id: 'fop4d9MPbN',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdTaskActive: {
    defaultMessage: '{count, plural, one {Creating task} other {Creating # tasks}}',
    id: '+kEhUH14J3',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdTaskPast: {
    defaultMessage: '{count, plural, one {Created task} other {Created # tasks}}',
    id: '7yKhZkSJqP',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdTaskPastPartial: {
    defaultMessage: 'Created {done} of {count} tasks',
    id: '0En2MLr7Cv',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  searchedPatientProfilesActive: {
    defaultMessage:
      '{count, plural, one {Searching patient profiles} other {Searching # patient profiles}}',
    id: '5TbR+wKLZ7',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  searchedPatientProfilesPast: {
    defaultMessage:
      '{count, plural, one {Searched patient profiles} other {Searched # patient profiles}}',
    id: 'mr2BrKg6ks',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  searchedPatientProfilesPastPartial: {
    defaultMessage: 'Searched {done} of {count} patient profiles',
    id: 'V4Dl7/Qp5+',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  loadedPatientContextActive: {
    defaultMessage:
      '{count, plural, one {Loading patient context} other {Loading # patient contexts}}',
    id: 'Xdv/Uc5SC9',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  loadedPatientContextPast: {
    defaultMessage:
      '{count, plural, one {Loaded patient context} other {Loaded # patient contexts}}',
    id: '/AUVISW4ag',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  loadedPatientContextPastPartial: {
    defaultMessage: 'Loaded {done} of {count} patient contexts',
    id: 'pZMcVHsoeg',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  loadedTemplatePreferencesActive: {
    defaultMessage:
      '{count, plural, one {Loading template & preferences} other {Loading # template & preferences}}',
    id: 'AA9desczyn',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  loadedTemplatePreferencesPast: {
    defaultMessage:
      '{count, plural, one {Loaded template & preferences} other {Loaded # template & preferences}}',
    id: 'AvqIcGgEBo',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  loadedTemplatePreferencesPastPartial: {
    defaultMessage: 'Loaded {done} of {count} template & preferences',
    id: 'HxzVmWad9B',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  searchedSessionsActive: {
    defaultMessage:
      '{count, plural, one {Searching sessions} other {Searching # sessions}}',
    id: 'FhVPeQcqTg',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  searchedSessionsPast: {
    defaultMessage:
      '{count, plural, one {Searched sessions} other {Searched # sessions}}',
    id: 'j3lhoSsddM',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  searchedSessionsPastPartial: {
    defaultMessage: 'Searched {done} of {count} sessions',
    id: 'jk1Vijoorv',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  gotTranscriptActive: {
    defaultMessage:
      '{count, plural, one {Getting transcript} other {Getting # transcripts}}',
    id: 'BM6kvCGAxs',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  gotTranscriptPast: {
    defaultMessage: '{count, plural, one {Got transcript} other {Got # transcripts}}',
    id: '7C/etp954m',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  gotTranscriptPastPartial: {
    defaultMessage: 'Got {done} of {count} transcripts',
    id: 'BAIn8T758N',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  openedArtifactActive: {
    defaultMessage: '{count, plural, one {Opening artifact} other {Opening # artifacts}}',
    id: 'VTVy2yZvMi',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  openedArtifactPast: {
    defaultMessage: '{count, plural, one {Opened artifact} other {Opened # artifacts}}',
    id: 'CqzTpV+yrW',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  openedArtifactPastPartial: {
    defaultMessage: 'Opened {done} of {count} artifacts',
    id: 'AjvxROVSF1',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  foundMergeableSessionsActive: {
    defaultMessage:
      '{count, plural, one {Finding mergeable sessions} other {Finding # mergeable sessions}}',
    id: 'ZzMusXU1zO',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  foundMergeableSessionsPast: {
    defaultMessage:
      '{count, plural, one {Found mergeable sessions} other {Found # mergeable sessions}}',
    id: 'nX+8o20q1h',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  foundMergeableSessionsPastPartial: {
    defaultMessage: 'Found {done} of {count} mergeable sessions',
    id: '2BBSJWnPyp',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  mergedSessionsActive: {
    defaultMessage: '{count, plural, one {Merging sessions} other {Merging # sessions}}',
    id: 'paGfgdMryu',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  mergedSessionsPast: {
    defaultMessage: '{count, plural, one {Merged sessions} other {Merged # sessions}}',
    id: 'pMeMi1U9eb',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  mergedSessionsPastPartial: {
    defaultMessage: 'Merged {done} of {count} sessions',
    id: '4W3FAcFKjp',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  unlinkedMergedSessionsActive: {
    defaultMessage:
      '{count, plural, one {Unlinking merged sessions} other {Unlinking # merged sessions}}',
    id: '31/af7QXrX',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  unlinkedMergedSessionsPast: {
    defaultMessage:
      '{count, plural, one {Unlinked merged sessions} other {Unlinked # merged sessions}}',
    id: 'IOALVJS6rE',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  unlinkedMergedSessionsPastPartial: {
    defaultMessage: 'Unlinked {done} of {count} merged sessions',
    id: '+vg/9DhUdc',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  dismissedMergeSuggestionActive: {
    defaultMessage:
      '{count, plural, one {Dismissing merge suggestion} other {Dismissing # merge suggestions}}',
    id: '9kF31zwK6F',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  dismissedMergeSuggestionPast: {
    defaultMessage:
      '{count, plural, one {Dismissed merge suggestion} other {Dismissed # merge suggestions}}',
    id: 'ej5Gocjz7J',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  dismissedMergeSuggestionPastPartial: {
    defaultMessage: 'Dismissed {done} of {count} merge suggestions',
    id: 'IwMLLlbKuX',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  lookedUpTeamMembersActive: {
    defaultMessage:
      '{count, plural, one {Looking up team members} other {Looking up # team members}}',
    id: 'nUQrMoWAoe',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  lookedUpTeamMembersPast: {
    defaultMessage:
      '{count, plural, one {Looked up team members} other {Looked up # team members}}',
    id: 'iYluhca6kG',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  lookedUpTeamMembersPastPartial: {
    defaultMessage: 'Looked up {done} of {count} team members',
    id: '9ByMFVZzP/',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  sharedSessionActive: {
    defaultMessage: '{count, plural, one {Sharing session} other {Sharing # sessions}}',
    id: 'jfOsS9qeD1',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  sharedSessionPast: {
    defaultMessage: '{count, plural, one {Shared session} other {Shared # sessions}}',
    id: 'ZLE+w+v0Th',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  sharedSessionPastPartial: {
    defaultMessage: 'Shared {done} of {count} sessions',
    id: '+yUndGUDfL',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  revokedSessionAccessActive: {
    defaultMessage:
      '{count, plural, one {Revoking session access} other {Revoking # session access}}',
    id: 'ni88HfaErE',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  revokedSessionAccessPast: {
    defaultMessage:
      '{count, plural, one {Revoked session access} other {Revoked # session access}}',
    id: 'Y9YNzDlibB',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  revokedSessionAccessPastPartial: {
    defaultMessage: 'Revoked {done} of {count} session access',
    id: 'q1xsusVWOp',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedSessionSharesActive: {
    defaultMessage:
      '{count, plural, one {Listing session shares} other {Listing # session shares}}',
    id: 'fI0bT58QPf',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedSessionSharesPast: {
    defaultMessage:
      '{count, plural, one {Listed session shares} other {Listed # session shares}}',
    id: 'Yk97qZAGeo',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedSessionSharesPastPartial: {
    defaultMessage: 'Listed {done} of {count} session shares',
    id: 'A6HW+oZyE8',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  invitedTeamMemberActive: {
    defaultMessage:
      '{count, plural, one {Inviting team member} other {Inviting # team members}}',
    id: 'Yf/RQ9P7Lm',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  invitedTeamMemberPast: {
    defaultMessage:
      '{count, plural, one {Invited team member} other {Invited # team members}}',
    id: 'lE86XGui3f',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  invitedTeamMemberPastPartial: {
    defaultMessage: 'Invited {done} of {count} team members',
    id: 'yaQxUkyhef',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  removedTeamMemberActive: {
    defaultMessage:
      '{count, plural, one {Removing team member} other {Removing # team members}}',
    id: 'edKxND8r65',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  removedTeamMemberPast: {
    defaultMessage:
      '{count, plural, one {Removed team member} other {Removed # team members}}',
    id: 'K+Lkh5qBOr',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  removedTeamMemberPastPartial: {
    defaultMessage: 'Removed {done} of {count} team members',
    id: '9G9d+kk8vV',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  sharedTemplateActive: {
    defaultMessage: '{count, plural, one {Sharing template} other {Sharing # templates}}',
    id: '0Ijg7PlYYp',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  sharedTemplatePast: {
    defaultMessage: '{count, plural, one {Shared template} other {Shared # templates}}',
    id: '7C/beZF+VZ',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  sharedTemplatePastPartial: {
    defaultMessage: 'Shared {done} of {count} templates',
    id: 'qKZNcLEF+j',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  revokedTemplateAccessActive: {
    defaultMessage:
      '{count, plural, one {Revoking template access} other {Revoking # template access}}',
    id: 'iodcmaQaC4',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  revokedTemplateAccessPast: {
    defaultMessage:
      '{count, plural, one {Revoked template access} other {Revoked # template access}}',
    id: 'B7kyQ0iO/r',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  revokedTemplateAccessPastPartial: {
    defaultMessage: 'Revoked {done} of {count} template access',
    id: 'QJNXj4lAic',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  generatedCSVActive: {
    defaultMessage: '{count, plural, one {Generating CSV} other {Generating # CSVs}}',
    id: 'C9oNpaBdM+',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  generatedCSVPast: {
    defaultMessage: '{count, plural, one {Generated CSV} other {Generated # CSVs}}',
    id: 'JX5PHZLSYC',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  generatedCSVPastPartial: {
    defaultMessage: 'Generated {done} of {count} CSVs',
    id: 'TZjLfwhyzM',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  generatedSpreadsheetActive: {
    defaultMessage:
      '{count, plural, one {Generating spreadsheet} other {Generating # spreadsheets}}',
    id: '+MMpC+d5MK',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  generatedSpreadsheetPast: {
    defaultMessage:
      '{count, plural, one {Generated spreadsheet} other {Generated # spreadsheets}}',
    id: 'dScHsUhA0o',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  generatedSpreadsheetPastPartial: {
    defaultMessage: 'Generated {done} of {count} spreadsheets',
    id: 'd1WBgoV7r5',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  generatedPresentationActive: {
    defaultMessage:
      '{count, plural, one {Generating presentation} other {Generating # presentations}}',
    id: 'Lq0vQWa/bQ',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  generatedPresentationPast: {
    defaultMessage:
      '{count, plural, one {Generated presentation} other {Generated # presentations}}',
    id: 'quEEBcHbPA',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  generatedPresentationPastPartial: {
    defaultMessage: 'Generated {done} of {count} presentations',
    id: '6tvNDwvF8V',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  readPresentationSlidesActive: {
    defaultMessage:
      '{count, plural, one {Reading presentation} other {Reading # presentations}}',
    id: 'FU0SCEu/bv',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  readPresentationSlidesPast: {
    defaultMessage:
      '{count, plural, one {Read presentation} other {Read # presentations}}',
    id: 'R9SheUHdvj',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  readPresentationSlidesPastPartial: {
    defaultMessage: 'Read {done} of {count} presentations',
    id: 'jxNCaMENXT',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  editedSlideActive: {
    defaultMessage: '{count, plural, one {Updating slide} other {Updating # slides}}',
    id: 'AFdsetOPFG',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  editedSlidePast: {
    defaultMessage: '{count, plural, one {Updated slide} other {Updated # slides}}',
    id: 'J/f4CjOSFZ',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  editedSlidePastPartial: {
    defaultMessage: 'Updated {done} of {count} slides',
    id: 'Kl0mnxB8hm',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  addedSlidesActive: {
    defaultMessage: 'Adding slides',
    id: 'zUi4+1+XJp',
    description: 'Work timeline tool row while running',
  },
  addedSlidesPast: {
    defaultMessage: 'Added slides',
    id: '5d0lYZJUf7',
    description: 'Work timeline tool row after success',
  },
  addedSlidesPastPartial: {
    defaultMessage: 'Added slides in {done} of {count} calls',
    id: '0//Iir2Bl9',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  deletedSlideActive: {
    defaultMessage: '{count, plural, one {Removing slide} other {Removing # slides}}',
    id: 'G/hNH1/Og7',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  deletedSlidePast: {
    defaultMessage: '{count, plural, one {Removed slide} other {Removed # slides}}',
    id: 'VN0s+ltwfF',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  deletedSlidePastPartial: {
    defaultMessage: 'Removed {done} of {count} slides',
    id: 'wwsPKNfiKN',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  generatedDocumentActive: {
    defaultMessage:
      '{count, plural, one {Generating document} other {Generating # documents}}',
    id: 'BGXtoid0IS',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  generatedDocumentPast: {
    defaultMessage:
      '{count, plural, one {Generated document} other {Generated # documents}}',
    id: 'm7dqWQaU+4',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  generatedDocumentPastPartial: {
    defaultMessage: 'Generated {done} of {count} documents',
    id: 'cnfJnlU6eD',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  exportedWordDocumentActive: {
    defaultMessage:
      '{count, plural, one {Exporting Word document} other {Exporting # Word documents}}',
    id: 'aE0MIavGVB',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  exportedWordDocumentPast: {
    defaultMessage:
      '{count, plural, one {Exported Word document} other {Exported # Word documents}}',
    id: 'WGoXo6W8Dm',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  exportedWordDocumentPastPartial: {
    defaultMessage: 'Exported {done} of {count} Word documents',
    id: '0q9uLcdKGi',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  exportedPDFActive: {
    defaultMessage: '{count, plural, one {Exporting PDF} other {Exporting # PDFs}}',
    id: 'b67SBjHxUd',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  exportedPDFPast: {
    defaultMessage: '{count, plural, one {Exported PDF} other {Exported # PDFs}}',
    id: 'Yi9+NlJe8o',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  exportedPDFPastPartial: {
    defaultMessage: 'Exported {done} of {count} PDFs',
    id: '2ItI9J43bW',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdEvidencePDFActive: {
    defaultMessage:
      '{count, plural, one {Creating evidence PDF} other {Creating # evidence PDFs}}',
    id: 'qyBwlSK7ex',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdEvidencePDFPast: {
    defaultMessage:
      '{count, plural, one {Created evidence PDF} other {Created # evidence PDFs}}',
    id: '1M7QHIfZZJ',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdEvidencePDFPastPartial: {
    defaultMessage: 'Created {done} of {count} evidence PDFs',
    id: 'NaXjZjrzPm',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  filledPDFFormActive: {
    defaultMessage: '{count, plural, one {Filling PDF form} other {Filling # PDF forms}}',
    id: '3Q9CBjDyZg',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  filledPDFFormPast: {
    defaultMessage: '{count, plural, one {Filled PDF form} other {Filled # PDF forms}}',
    id: '9riK40c/bz',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  filledPDFFormPastPartial: {
    defaultMessage: 'Filled {done} of {count} PDF forms',
    id: 'cPCq8Be2V2',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  filledFormActive: {
    defaultMessage: '{count, plural, one {Filling form} other {Filling # forms}}',
    id: 'mSelGnrt0P',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  filledFormPast: {
    defaultMessage: '{count, plural, one {Filled form} other {Filled # forms}}',
    id: 'l8F8Q/7hcN',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  filledFormPastPartial: {
    defaultMessage: 'Filled {done} of {count} forms',
    id: 'zS5pXTp7v2',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  filledWordFormActive: {
    defaultMessage:
      '{count, plural, one {Filling Word form} other {Filling # Word forms}}',
    id: 'fDAEMrJ6aa',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  filledWordFormPast: {
    defaultMessage: '{count, plural, one {Filled Word form} other {Filled # Word forms}}',
    id: 'RIDz9AZ2e4',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  filledWordFormPastPartial: {
    defaultMessage: 'Filled {done} of {count} Word forms',
    id: 'UATc+Tfj+B',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedFormFieldsActive: {
    defaultMessage:
      '{count, plural, one {Listing form fields} other {Listing # form fields}}',
    id: 'p3HCW2/PUQ',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedFormFieldsPast: {
    defaultMessage:
      '{count, plural, one {Listed form fields} other {Listed # form fields}}',
    id: 'P3wxndCcSW',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedFormFieldsPastPartial: {
    defaultMessage: 'Listed {done} of {count} form fields',
    id: 'RGAHUWdGcs',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  filledExcelTemplateActive: {
    defaultMessage:
      '{count, plural, one {Filling Excel template} other {Filling # Excel templates}}',
    id: '4qLDadYcNd',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  filledExcelTemplatePast: {
    defaultMessage:
      '{count, plural, one {Filled Excel template} other {Filled # Excel templates}}',
    id: 'k5L0CXGLSB',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  filledExcelTemplatePastPartial: {
    defaultMessage: 'Filled {done} of {count} Excel templates',
    id: 'XVbBsR5kK3',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedExcelLayoutActive: {
    defaultMessage:
      '{count, plural, one {Listing Excel layout} other {Listing # Excel layouts}}',
    id: 'JrLPwVZMMH',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedExcelLayoutPast: {
    defaultMessage:
      '{count, plural, one {Listed Excel layout} other {Listed # Excel layouts}}',
    id: 'WtCfXmAwlt',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedExcelLayoutPastPartial: {
    defaultMessage: 'Listed {done} of {count} Excel layouts',
    id: 'H/oLF/pyEO',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedLibraryCollectionsActive: {
    defaultMessage:
      '{count, plural, one {Listing library collections} other {Listing # library collections}}',
    id: 'Ko30FmqlUn',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedLibraryCollectionsPast: {
    defaultMessage:
      '{count, plural, one {Listed library collections} other {Listed # library collections}}',
    id: '3tUyqmzfNm',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedLibraryCollectionsPastPartial: {
    defaultMessage: 'Listed {done} of {count} library collections',
    id: 'pMLQGiVXcF',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  loadedLibraryCollectionActive: {
    defaultMessage:
      '{count, plural, one {Loading library collection} other {Loading # library collections}}',
    id: 'TkKMOAmR9/',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  loadedLibraryCollectionPast: {
    defaultMessage:
      '{count, plural, one {Loaded library collection} other {Loaded # library collections}}',
    id: 'NU5tZFoJ6X',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  loadedLibraryCollectionPastPartial: {
    defaultMessage: 'Loaded {done} of {count} library collections',
    id: '7z5Z3a0YRO',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdLibraryCollectionActive: {
    defaultMessage:
      '{count, plural, one {Creating library collection} other {Creating # library collections}}',
    id: 'iP43vFHiIB',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdLibraryCollectionPast: {
    defaultMessage:
      '{count, plural, one {Created library collection} other {Created # library collections}}',
    id: 'xFuaIR8inc',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdLibraryCollectionPastPartial: {
    defaultMessage: 'Created {done} of {count} library collections',
    id: 'LcSlWqB3A1',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  updatedLibraryCollectionActive: {
    defaultMessage:
      '{count, plural, one {Updating library collection} other {Updating # library collections}}',
    id: 'q4j41HGl87',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  updatedLibraryCollectionPast: {
    defaultMessage:
      '{count, plural, one {Updated library collection} other {Updated # library collections}}',
    id: 'NdPPE6gP08',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  updatedLibraryCollectionPastPartial: {
    defaultMessage: 'Updated {done} of {count} library collections',
    id: 'HmdfbjV3xn',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  deletedLibraryCollectionActive: {
    defaultMessage:
      '{count, plural, one {Deleting library collection} other {Deleting # library collections}}',
    id: 'o8nMZ9JBJ3',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  deletedLibraryCollectionPast: {
    defaultMessage:
      '{count, plural, one {Deleted library collection} other {Deleted # library collections}}',
    id: 'kWO9UGrIz9',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  deletedLibraryCollectionPastPartial: {
    defaultMessage: 'Deleted {done} of {count} library collections',
    id: 'VSxk7I2V7Z',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  savedWorkArtefactActive: {
    defaultMessage: '{count, plural, one {Saving Artefact} other {Saving # Artefacts}}',
    id: 'ka84LSAXmu',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  savedWorkArtefactPast: {
    defaultMessage: '{count, plural, one {Saved Artefact} other {Saved # Artefacts}}',
    id: 'A0SpCABCMV',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  savedWorkArtefactPastPartial: {
    defaultMessage: 'Saved {done} of {count} Artefacts',
    id: 'FOnUfS34UW',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  editedConsultNoteActive: {
    defaultMessage:
      '{count, plural, one {Editing consult note} other {Editing # consult notes}}',
    id: 'vEkZEsq0ub',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  editedConsultNotePast: {
    defaultMessage:
      '{count, plural, one {Edited consult note} other {Edited # consult notes}}',
    id: 'kDu1XCMJjC',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  editedConsultNotePastPartial: {
    defaultMessage: 'Edited {done} of {count} consult notes',
    id: 'yNMYOGh4yz',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  readConsultNoteActive: {
    defaultMessage:
      '{count, plural, one {Reading consult note} other {Reading # consult notes}}',
    id: 'DO851mz49C',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  readConsultNotePast: {
    defaultMessage:
      '{count, plural, one {Read consult note} other {Read # consult notes}}',
    id: 'QhfTpR4qGg',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  readConsultNotePastPartial: {
    defaultMessage: 'Read {done} of {count} consult notes',
    id: '3kql2qx2nl',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  updatedTranscriptionActive: {
    defaultMessage:
      '{count, plural, one {Updating transcription} other {Updating # transcriptions}}',
    id: 'JfZzG0GIb2',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  updatedTranscriptionPast: {
    defaultMessage:
      '{count, plural, one {Updated transcription} other {Updated # transcriptions}}',
    id: 'yXTE7qvXVZ',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  updatedTranscriptionPastPartial: {
    defaultMessage: 'Updated {done} of {count} transcriptions',
    id: 'Ckk6kXdLuc',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  transcribedAttachmentActive: {
    defaultMessage:
      '{count, plural, one {Transcribing attachment} other {Transcribing # attachments}}',
    id: 'YgkB5D9w70',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  transcribedAttachmentPast: {
    defaultMessage:
      '{count, plural, one {Transcribed attachment} other {Transcribed # attachments}}',
    id: '1aZ8Iyl5yj',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  transcribedAttachmentPastPartial: {
    defaultMessage: 'Transcribed {done} of {count} attachments',
    id: 'AomNVIxvn4',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  generatedConsultNoteActive: {
    defaultMessage:
      '{count, plural, one {Generating consult note} other {Generating # consult notes}}',
    id: 'SEpFoXDEre',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  generatedConsultNotePast: {
    defaultMessage:
      '{count, plural, one {Generated consult note} other {Generated # consult notes}}',
    id: 'EI3xg1uVAb',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  generatedConsultNotePastPartial: {
    defaultMessage: 'Generated {done} of {count} consult notes',
    id: 'dyt9ty8ADh',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  checkedLiteratureActive: {
    defaultMessage:
      '{count, plural, one {Checking the literature and guidelines} other {Running # literature and guideline checks}}',
    id: 'hUCn9xGNBx',
    description:
      'Work timeline row while an Evidence call runs, naming the work rather than the tool (an Evidence badge sits beside it); count = number of grouped calls',
  },
  checkedLiteraturePast: {
    defaultMessage:
      '{count, plural, one {Checked the literature and guidelines} other {Ran # literature and guideline checks}}',
    id: 'dNvHr7ydTz',
    description:
      'Work timeline row after an Evidence call succeeds, naming the work rather than the tool (an Evidence badge sits beside it); count = number of grouped calls',
  },
  checkedLiteraturePastPartial: {
    defaultMessage: 'Ran {done} of {count} literature and guideline checks',
    id: 'VpEQ+5/Hku',
    description:
      'Work timeline grouped Evidence row when only some calls finished; done of count',
  },
  ranVerificationActive: {
    defaultMessage:
      '{count, plural, one {Running verification} other {Running # verifications}}',
    id: 'QUpBeJ6kCD',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  ranVerificationPast: {
    defaultMessage: '{count, plural, one {Ran verification} other {Ran # verifications}}',
    id: '7sum6VZvro',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  ranVerificationPastPartial: {
    defaultMessage: 'Ran {done} of {count} verifications',
    id: 'YAS0WIckQJ',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdRoutineActive: {
    defaultMessage: '{count, plural, one {Creating routine} other {Creating # routines}}',
    id: 'Wk0KoDf8Ta',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdRoutinePast: {
    defaultMessage: '{count, plural, one {Created routine} other {Created # routines}}',
    id: 'UNjwNvMCOI',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdRoutinePastPartial: {
    defaultMessage: 'Created {done} of {count} routines',
    id: 't0Cho1LJdq',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  updatedRoutineActive: {
    defaultMessage: '{count, plural, one {Updating routine} other {Updating # routines}}',
    id: 'S+8TExp0sU',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  updatedRoutinePast: {
    defaultMessage: '{count, plural, one {Updated routine} other {Updated # routines}}',
    id: 'dpfY+ycRKi',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  updatedRoutinePastPartial: {
    defaultMessage: 'Updated {done} of {count} routines',
    id: 'gq+ygAQAsN',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  scheduledRoutineActive: {
    defaultMessage:
      '{count, plural, one {Scheduling routine} other {Scheduling # routines}}',
    id: '4oWHoe+1q5',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  scheduledRoutinePast: {
    defaultMessage:
      '{count, plural, one {Scheduled routine} other {Scheduled # routines}}',
    id: 'H6hImZv8bu',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  scheduledRoutinePastPartial: {
    defaultMessage: 'Scheduled {done} of {count} routines',
    id: 'PEbtSrSQGG',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  setRoutineTriggersActive: {
    defaultMessage:
      '{count, plural, one {Setting routine triggers} other {Setting # routine triggers}}',
    id: 'nXzWbDN/qn',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  setRoutineTriggersPast: {
    defaultMessage:
      '{count, plural, one {Set routine triggers} other {Set # routine triggers}}',
    id: 'UlqYwWsLqN',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  setRoutineTriggersPastPartial: {
    defaultMessage: 'Set {done} of {count} routine triggers',
    id: 'WVjC7KMKdH',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  listedDirectoryActive: {
    defaultMessage:
      '{count, plural, one {Listing directory} other {Listing # directories}}',
    id: '52eSfNv92A',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  listedDirectoryPast: {
    defaultMessage:
      '{count, plural, one {Listed directory} other {Listed # directories}}',
    id: 'yJZt3ko7tu',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  listedDirectoryPastPartial: {
    defaultMessage: 'Listed {done} of {count} directories',
    id: 'yjfQQC4DJT',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  readFileActive: {
    defaultMessage: '{count, plural, one {Reading file} other {Reading # files}}',
    id: 'JKd0+OQeCw',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  readFilePast: {
    defaultMessage: '{count, plural, one {Read file} other {Read # files}}',
    id: 'Wo3LDapo1/',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  readFilePastPartial: {
    defaultMessage: 'Read {done} of {count} files',
    id: 'RHSrrrd0RS',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  searchedFilesActive: {
    defaultMessage: '{count, plural, one {Searching files} other {Searching # files}}',
    id: 'EhcpFK6dFr',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  searchedFilesPast: {
    defaultMessage: '{count, plural, one {Searched files} other {Searched # files}}',
    id: 'i7zW1RYTEW',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  searchedFilesPastPartial: {
    defaultMessage: 'Searched {done} of {count} files',
    id: 'fFcyD3ICIB',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  checkedFileDetailsActive: {
    defaultMessage:
      '{count, plural, one {Checking file details} other {Checking # file details}}',
    id: 'EwcvrSzRpK',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  checkedFileDetailsPast: {
    defaultMessage:
      '{count, plural, one {Checked file details} other {Checked # file details}}',
    id: 'WdJgNxUFBK',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  checkedFileDetailsPastPartial: {
    defaultMessage: 'Checked {done} of {count} file details',
    id: 'knPI+Txcy9',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  createdFileActive: {
    defaultMessage: '{count, plural, one {Creating file} other {Creating # files}}',
    id: 'J3rkTdnvb7',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  createdFilePast: {
    defaultMessage: '{count, plural, one {Created file} other {Created # files}}',
    id: 'r/E2CcKNW2',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  createdFilePastPartial: {
    defaultMessage: 'Created {done} of {count} files',
    id: '6vLPyA7WC2',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  renamedFileActive: {
    defaultMessage: '{count, plural, one {Renaming file} other {Renaming # files}}',
    id: 'fz5XvuefuJ',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  renamedFilePast: {
    defaultMessage: '{count, plural, one {Renamed file} other {Renamed # files}}',
    id: 'CFVDtvXwml',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  renamedFilePastPartial: {
    defaultMessage: 'Renamed {done} of {count} files',
    id: 'UcxjR0eIFH',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
  reportedIssueActive: {
    defaultMessage:
      '{count, plural, one {Reporting an issue} other {Reporting # issues}}',
    id: 'E8krezfOS0',
    description: 'Work timeline tool row while running; count = number of grouped calls',
  },
  reportedIssuePast: {
    defaultMessage: '{count, plural, one {Reported an issue} other {Reported # issues}}',
    id: 'NFUgodgVIe',
    description: 'Work timeline tool row after success; count = number of grouped calls',
  },
  reportedIssuePastPartial: {
    defaultMessage: 'Reported {done} of {count} issues',
    id: 'OoqLI5nygf',
    description:
      'Work timeline grouped tool row when only some calls finished; done of count',
  },
});
